import naja from "naja";

/**
 * Zajistí scroll k vršku požadovaného elementu po úspěšném provedení ajaxového požadavku.
 * Interagující element nebo jeho rodič vyžaduje atribut data-naja-scroll-target.
 * Cílový element se vyhledá podle data-naja-scroll-name.
 * hodnoty obou atributů musí být shodné
 */

export default class ScrollExtension {

    initialize(naja) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                naja.uiHandler.addEventListener('interaction', (event) => {this.locateTarget(event)});
                naja.addEventListener('success', (event) => {this.scrollToTarget(event)})
            });
        } else {
            naja.uiHandler.addEventListener('interaction', (event) => {this.locateTarget(event)});
            naja.addEventListener('success', (event) => {this.scrollToTarget(event)})
        }
    }

    /**
     * Podle data-naja-scroll-target kliknutého odkazu (nebo jeho rodiče) se uloží jméno cílového elementu, ke kterému se bude skrolovat.
     */
    locateTarget (event) {
        let element = event.detail.element; // element odkazu
        let scrollTargetName = element.closest("[data-naja-scroll-target]")?.dataset.najaScrollTarget;
        if (scrollTargetName) {
            event.detail.options.scrollTargetName = scrollTargetName;
        }
    }

    /**
     * Pokusí se najít cílový element a popř. k němu skroluje.
     */
    scrollToTarget (event) {
        let scrollTargetName = event.detail.options.scrollTargetName;
        if (scrollTargetName) {
            let scrollTarget = document.querySelector("[data-naja-scroll-name=" + scrollTargetName + "]");
            scrollTarget?.scrollIntoView();
        }
    }

}